import axios from 'axios';

export function getCSRFCookie() {
  // for django csrf protection
  let cookieValue = null;
  const name = 'csrftoken';
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === `${name}=`) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

const axiosInstance = axios.create();

axiosInstance.interceptors.request.use(
  (config) => {
    config.headers['X-CSRFToken'] = getCSRFCookie();
    return config;
  },
  (error) => Promise.reject(error),
);

export { axiosInstance };
